'use client';

import { NEXT_PUBLIC_IMAGE_URL } from '@/common';
import Image from 'next/image';
import { useState, useEffect, useRef } from 'react';

const logos = [
  // Notion
  <Image
    src={`${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/bosch.png`}
    alt="Notion"
    width={129}
    height={48}
    className="h-8 w-auto object-contain"
    key="notion"
  />,
  // Stripe
  <Image
    src={`${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/california-fitness-yoga.png`}
    alt="Stripe"
    width={80}
    height={48}
    className="h-8 w-auto object-contain"
    key="stripe"
  />,
  // Dropbox
  <Image
    src={`${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/carlsberg-vietnam.png`}
    alt="Dropbox"
    width={163}
    height={48}
    className="h-8 w-auto object-contain"
    key="dropbox"
  />,
  // Shopify
  <Image
    src={`${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/daikin.png`}
    alt="Shopify"
    width={127}
    height={48}
    className="h-8 w-auto object-contain"
    key="shopify"
  />,
  // Slack
  <Image
    src={`${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/home-credit.png`}
    alt="Slack"
    width={122}
    height={48}
    className="h-8 w-auto object-contain"
    key="slack"
  />,
  // Slack
  <Image
    src={`${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/maersk.png`}
    alt="Slack"
    width={122}
    height={48}
    className="h-8 w-auto object-contain"
    key="slack"
  />,
  // Slack
  <Image
    src={`${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/masan-group.png`}
    alt="Slack"
    width={122}
    height={48}
    className="h-8 w-auto object-contain"
    key="slack"
  />,
  // Slack
  <Image
    src={`${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/mb-bank.png`}
    alt="Slack"
    width={122}
    height={48}
    className="h-8 w-auto object-contain"
    key="slack"
  />,
  // Slack
  <Image
    src={`${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/techcombank.png`}
    alt="Slack"
    width={122}
    height={48}
    className="h-8 w-auto object-contain"
    key="slack"
  />,
  <Image
    src={`${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/thac-auto.png`}
    alt="Slack"
    width={122}
    height={48}
    className="h-8 w-auto object-contain"
    key="slack"
  />,
  <Image
    src={`${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/vin-group.png`}
    alt="Slack"
    width={122}
    height={48}
    className="h-8 w-auto object-contain"
    key="slack"
  />,
  <Image
    src={`${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/vinamilk.png`}
    alt="Slack"
    width={122}
    height={48}
    className="h-8 w-auto object-contain"
    key="slack"
  />,
  <Image
    src={`${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/vnpay.png`}
    alt="Slack"
    width={122}
    height={48}
    className="h-8 w-auto object-contain"
    key="slack"
  />,
];

const Logos: React.FC = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const containerRef = useRef<HTMLDivElement>(null);
  const totalRounds = 4;

  useEffect(() => {
    let totalWidth = 0;
    let animationFrame: number;
    const step = () => {
      setScrollPosition(prev => {
        if (containerRef.current) {
          totalWidth = containerRef.current.scrollWidth / totalRounds;
        }
        const newPosition = prev + 1.5;

        if (totalWidth > 0 && newPosition >= totalWidth) {
          setIsTransitioning(true);
          // Chạy đến cuối, chuyển sang đầu bằng hiệu ứng
          setTimeout(() => {
            setIsTransitioning(false); // Tắt transition
            setScrollPosition(0); // Nhảy về đầu ngay lập tức
            setTimeout(() => {
              setIsTransitioning(true); // Bật lại transition
            }, 20); // Đợi một chút để browser apply style
          }, 50); // Đợi hiệu ứng chạy xong

          return newPosition;
        }

        return newPosition;
      });
      animationFrame = requestAnimationFrame(step);
    };

    animationFrame = requestAnimationFrame(step);

    return () => cancelAnimationFrame(animationFrame);
  }, []);

  return (
    <section
      id="logos"
      className="bg-background py-32"
      style={{
        backgroundImage: `url('${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/logos_pattern.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#e0e722',
      }}
    >
      <h2 className="mx-auto mb-16 text-center text-3xl font-bold lg:max-w-3xl lg:text-5xl lg:leading-tight">
        Nhiều doanh nghiệp đang tìm &quot;tân binh&quot; giỏi – giống bạn đó!
      </h2>
      <div className="relative w-full overflow-hidden">
        <div
          ref={containerRef}
          className="flex min-w-max gap-10"
          style={{
            transform: `translateX(-${scrollPosition}px)`,
            transition: isTransitioning ? 'transform 0.05s linear' : 'none',
          }}
        >
          {[...logos, ...logos, ...logos, ...logos].map((logo, idx) => (
            <div
              key={idx}
              className="flex flex-shrink-0 items-center justify-center rounded-[20px] bg-white px-6 py-3 md:px-5 md:py-4"
            >
              {logo}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Logos;
